<template>
  <section>
    <div class="l-service">
      <div class="l-service-header">
        <h2 class="heading-default heading-default-center">免責事項</h2>
        <h3 class="heading-small heading-small-center heading-small-mt-sp">
          DISCLAIMER
        </h3>

        <div class="l-service-content-inner">
          <h2 class="heading-coating heading-coating-small">
            1. IR情報ご利用にあたって
          </h2>
          <p class="sentence sentence-mt sentence-ir-mb">
            当ウェブサイトに掲載しているIR情報は、株式会社旅工房（以下、当社）の財務情報、経営指標等の提供を目的としておりますが、内容についていかなる表明・保証を行うものではありません。
            <br />また、当ウェブサイトへの情報の掲載は、投資勧誘を目的にしたものではありません。実際に投資を行う際は、当ウェブサイトの情報に全面的に依拠して投資判断を下すことはお控えいただき、投資に関するご決定は皆様ご自身のご判断で行うようお願いいたします。
          </p>
          <h2 class="heading-coating heading-coating-small">
            2. 掲載情報に関して
          </h2>
          <p class="sentence sentence-mt sentence-ir-mb">
            当ウェブサイトに掲載している情報に関して、当社は細心の注意を払っておりますが、掲載した情報に誤りがあった場合や、第三者によりデータの改ざん、データダウンロード等によって生じた障害等に関し、事由の如何を問わずに一切責任を負うものではありません。
          </p>
          <h2 class="heading-coating heading-coating-small">
            3. 将来の見通しについて
          </h2>
          <p class="sentence sentence-mt sentence-ir-mb">
            当ウェブサイトに掲載している情報の一部には、将来の業績に関する記述が含まれています。こうした記述は、将来の業績を保証するものではなく、リスクや不確実性を内包するものです。将来の業績は環境の変化などにより、実際の結果と異なる可能性があることにご留意ください。
          </p>
          <h2 class="heading-coating heading-coating-small">
            4. 当ウェブサイトの運用に関して
          </h2>
          <p class="sentence sentence-mt sentence-ir-mb">
            当ウェブサイトは予告なしに運営の中断、中止や内容の変更を行うことがあります。
            <br />また、通信環境やお客様のコンピュータの状況、その他の理由により当ウェブサイトを正常に利用できない場合があります。これらによって生じた如何なるトラブル・損失・損害に対しても責任を負うものではないことを予めご了承ください。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "免責事項",
      titleTemplate: "免責事項 | IR情報 | 株式会社 旅工房",
    };
  },
};
</script>
